import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Footer from './components/Footer';
import PolicyModal from './components/PolicyModal';

function App() {
  const [selectedPolicy, setSelectedPolicy] = React.useState(null);

  const handleOpenPolicy = (policy) => {
    setSelectedPolicy(policy);
  };

  const handleClosePolicy = () => {
    setSelectedPolicy(null);
  };

  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Footer onOpenPolicy={handleOpenPolicy} />
      {selectedPolicy && (
        <PolicyModal
          slug={selectedPolicy.slug}
          title={selectedPolicy.title}
          onClose={handleClosePolicy}
        />
      )}
    </div>
  );
}

export default App;

